<template>
  <div
    class="accordion-item"
    :class="isOpen ? 'is-open' : ''"
  >
    <button
      :class="['accordion__button', additionalButtonClasses]"
      :aria-expanded="isOpen"
      :aria-controls="accordionId"
      @click="toggleItem()"
    >
      <h3
        :id="titleId"
        class="accordion__title"
      >
        {{ title }}

        <a
          v-if="titleLink"
          :href="titleLink"
          class="text-xs text-black font-normal ml-2"
        >
          {{ titleLinkLabel }}
        </a>
      </h3>
    </button>
    <div
      :id="accordionId"
      class="accordion__content"
      :class="{ 'hidden': !isOpen, 'block': isOpen }"
      :aria-hidden="!isOpen"
      role="region"
      :aria-labelledby="titleId"
    >
      <div class="mt-2 mb-5">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KfAccordionItem',
  props: {
    title: {
      type: String,
      default: '<No title>',
    },
    titleLink: {
      type: String,
      default: '',
    },
    titleLinkLabel: {
      type: String,
      default: '',
    },
    isInitiallyOpen: {
      type: Boolean,
      default: false,
    },
    additionalButtonClasses: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isOpen: this.isInitiallyOpen,
      accordionId: `accordion-${this._uid}`,
      titleId: `accordion-title-${this._uid}`,
    };
  },
  methods: {
    toggleItem() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>
